import React from 'react';

export default function Terms() {
  return (
    <div className="px-4 md:px-16 my-8">
      <h1 className="text-center text-2xl md:text-4xl font-bold mb-4">Terms & Conditions</h1>
      <p className="mb-4">
        Welcome to the International Journal of Data Processing and Networking (IJDPN). By accessing or using our website, submitting articles, or participating as a reviewer or editor, you agree to the following terms and conditions. Please read them carefully.
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Acceptance of Terms</h2>
      <p className="mb-4">
        By using the IJDPN website and services, you acknowledge that you have read, understood, and agree to abide by these terms and conditions. If you do not agree with these terms, please refrain from using our website or services.
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Use of Website</h2>
      <p className="mb-4">
        You may use the IJDPN website for lawful purposes only. You agree to:
        <ul className="list-disc ml-6">
          <li>Access the website in accordance with all applicable laws and regulations.</li>
          <li>Not use the website in a way that disrupts its functionality or compromises its security.</li>
          <li>Not engage in any activity that infringes on the rights of others, including intellectual property rights.</li>
        </ul>
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Intellectual Property Rights</h2>
      <p className="mb-4">
        All content on the IJDPN website, including articles, manuscripts, reviews, logos, and trademarks, is the property of IJDPN or its authors and is protected by applicable intellectual property laws. You may not:
        <ul className="list-disc ml-6">
          <li>Reproduce, distribute, or modify any content without prior written consent from IJDPN or the respective authors.</li>
          <li>Use the journal’s name, logo, or content for unauthorized commercial purposes.</li>
        </ul>
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Article Submission and Publication</h2>
      <p className="mb-4">
        By submitting an article to IJDPN, you agree to the following terms:
        <ul className="list-disc ml-6">
          <li>Originality: The manuscript you submit must be your original work and not under consideration for publication elsewhere.</li>
          <li>Review Process: Your article will be subject to a peer review process, and the decision to accept or reject it for publication rests solely with the journal’s editorial team.</li>
          <li>Copyright: Upon acceptance of the article, you may be required to transfer certain copyright rights to IJDPN, such as the right to distribute and archive the article.</li>
          <li>Ethics: All submissions must adhere to the ethical standards of academic publishing, including avoiding plagiarism, data falsification, and conflicts of interest.</li>
        </ul>
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Reviewer Responsibilities</h2>
      <p className="mb-4">
        Reviewers participating in the peer review process must:
        <ul className="list-disc ml-6">
          <li>Provide objective, fair, and timely reviews.</li>
          <li>Maintain confidentiality regarding manuscripts they review.</li>
          <li>Disclose any conflicts of interest that may affect their impartiality.</li>
        </ul>
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Limitation of Liability</h2>
      <p className="mb-4">
        <ul className="list-disc ml-6">
          <li>IJDPN makes no guarantees regarding the accuracy, completeness, or reliability of the content provided on the website or in published articles. To the fullest extent permitted by law:</li>
          <li>IJDPN will not be liable for any direct, indirect, incidental, or consequential damages resulting from your use of or inability to use the website or its content.</li>
          <li>IJDPN does not guarantee uninterrupted or error-free access to the website.</li>
        </ul>
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Third-Party Links</h2>
      <p className="mb-4">
        The IJDPN website may contain links to third-party websites for reference purposes. These links are provided for convenience, and IJDPN is not responsible for the content, accuracy, or privacy practices of third-party sites.
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Privacy Policy</h2>
      <p className="mb-4">
        Your use of the IJDPN website is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal data. By using the website, you consent to the collection and use of your data in accordance with our Privacy Policy.
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Termination</h2>
      <p className="mb-4">
        IJDPN reserves the right to terminate or restrict your access to the website or its services at any time, without prior notice, for any violation of these terms or for any other reason at its sole discretion.
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Changes to Terms and Conditions</h2>
      <p className="mb-4">
        IJDPN may modify these terms and conditions at any time. Any changes will be posted on this page, and it is your responsibility to review them periodically. Continued use of the website after changes are posted constitutes acceptance of the revised terms.
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Governing Law</h2>
      <p className="mb-4">
        These terms and conditions are governed by and construed in accordance with the laws.
      </p>

      <h2 className="text-lg md:text-2xl mt-4">Contact Information</h2>
      <p>
        For any questions or concerns regarding these Terms and Conditions, please contact us at:
        <br />
        International Journal of Data Processing and Networking (IJDPN)
        <br />
        Email: [insert contact email]
        <br />
        Address: [insert office address]
        <br />
        These Terms and Conditions aim to clarify the legal aspects of using the IJDPN website and services, ensuring a transparent and responsible interaction between the journal, its users, and contributors.
      </p>
    </div>
  );
}
